import React, { Component } from 'react';
import PropTypes from 'prop-types';
import './RouteTitle.css';

class RouteTitle extends Component {
  static propTypes = {
    titles: PropTypes.arrayOf(PropTypes.string).isRequired,
  };

  render() {
    return (
      <div className="route-title">
        {this.props.titles.map((label, index) => {
          return (
            <span key={index} className={'subtitle-' + (index + 1)}>
              {index > 0 ? <span className="subtitle-slash">/</span> : null}
              {label}
            </span>
          );
        })}
      </div>
    );
  }
}

export default RouteTitle;



// WEBPACK FOOTER //
// ./src/components/shared/route-title/RouteTitle.js